import * as yup from "yup";

export const emailValidation = yup.string().trim().email("Invalid email address").required("");
